const vendorLocationReview = (() => {
    let vendorID;
    let locationReviewEntries;
    let oTable;
    let locationReviewPopup;
    let locations;
    let reviewTypes;
    let staffs;

    async function init(vendorId) {
        vendorID = vendorId;
        locationReviewEntries = await authorizationsAjax.getVenderLocationReviewEntriesAsync(vendorID);
        locations = await authorizationsAjax.getVendorLocationDropdownData();
        reviewTypes = await authorizationsAjax.getVendorLocationReviewTypeDropdownData();
        staffs = await authorizationsAjax.getVendorLocationReviewStaffDropdownData();
    }

    function getMarkup() {
        const locatationReviewWrap = document.createElement('div');
        locatationReviewWrap.classList.add('planSummary');

        const importantTables = buildNewVendorLocationReviewForm();
        locatationReviewWrap.appendChild(importantTables);

        return locatationReviewWrap;
    }

    function buildNewVendorLocationReviewForm() {
        const locatationReviewDiv = document.createElement('div');
        locatationReviewDiv.classList.add('additionalQuestionWrap');

        locationReviewEntriesTable = buildLocationReviewEntriesTable();

        // Set the data type for each header, for sorting purposes
        const headers = locationReviewEntriesTable.querySelectorAll('.header div');
        headers[0].setAttribute('data-type', 'string'); // Location
        headers[1].setAttribute('data-type', 'string'); // Review Type
        headers[2].setAttribute('data-type', 'date'); // Due Date 
        headers[3].setAttribute('data-type', 'date'); // Completed Date 
        headers[4].setAttribute('data-type', 'string'); //  Responsible Staff  


        const column1 = document.createElement('div')
        column1.classList.add('col-1')
        const addNewCard = document.createElement("div");
        addNewCard.classList.add("card");
        const addNewCardBody = document.createElement("div");
        addNewCardBody.classList.add("card__body");
        addNewCard.innerHTML = `<div class="card__header">Location Review</div>`;
        addNewCard.appendChild(addNewCardBody)
        column1.appendChild(addNewCard)

        addNewCardBody.appendChild(locationReviewEntriesTable);
        locatationReviewDiv.appendChild(column1);

        // Call function to allow table sorting by clicking on a header.
        table.sortTableByHeader(locationReviewEntriesTable); 

        return locatationReviewDiv;
    }

    function buildLocationReviewEntriesTable() {
        const tableOptions = {
            plain: false,
            tableId: 'vendorInfoTable', 
            columnHeadings: ['Location ', 'Review Type', 'Due Date', 'Completed Date', 'Responsible Staff'],
            endIcon: false,
            callback: function (event) {
                let id = event.target.getAttribute('data-id');
                const entry = locationReviewEntries.getVenderLocationReviewEntriesResult.find(e => e.vendorLocationReviewId === id);               
                if (entry) {
                    showLocationReviewPopup({
                        id: entry.vendorLocationReviewId,
                        locationId: entry.locationId,
                        reviewTypeId: entry.locationReviewId,
                        staffId: entry.staffId,
                        dueDate: moment(entry.dueDate).format('YYYY-MM-DD'),
                        completedDate: entry.completedDate !== ''? moment(entry.completedDate).format('YYYY-MM-DD'):'',
                    });
                }
            },
        };
       
        oTable = table.build(tableOptions);
        populateTable();

        return oTable;
    }
    function populateTable() {
        let tableData = locationReviewEntries.getVenderLocationReviewEntriesResult.map((entry) => ({
            attributes: [{ key: 'data-id', value: entry.vendorLocationReviewId }], 
            values: [entry.location, entry.reviewType, entry.dueDate == '' ? '' : moment(entry.dueDate).format('MM/DD/YYYY'), entry.completedDate == '' ? '' : moment(entry.completedDate).format('MM/DD/YYYY'), entry.responsibleStaff],
        }));
        table.populate(oTable, tableData);
    }
    function showLocationReviewPopup(data) {
        let locationId = data?.locationId || null;
        let reviewTypeId = data?.reviewTypeId || null;
        let staffId = data?.staffId || null;
        let dueDateValue = data?.dueDate || null;
        let completedDateValue = data?.completedDate || null;
        let isReadOnly = false;

        if (!data) {
            if ($.session.authorizationInsertVendorInfo) isReadOnly = false;
            else if (!$.session.authorizationInsertVendorInfo) isReadOnly = true;
        }
        else if (data) {
            if ($.session.authorizationsVendorInfoUpdate) isReadOnly = false;
            else if (!$.session.authorizationsVendorInfoUpdate) isReadOnly = true;
        }

        locationReviewPopup = POPUP.build({
            header: data ? 'Edit Location Review' : 'Add New Location Review',
            id: 'locationReviewPopup',
        });

        const locationDropdown = dropdown.build({
            id: 'locationDropdown',
            label: 'Location',
            dropdownId: 'locationDropdown',
            value: '',
            readonly: isReadOnly
        });
        const locationData = JSON.parse(locations.getVendorLocationDropdownDataResult) || [];
        var defaultDropdownOption = { value: '', text: '' };
        locationData.unshift(defaultDropdownOption);
        dropdown.populate(locationDropdown, locationData, locationId|| '');

        const reviewDropdown = dropdown.build({
            id: 'reviewDropdown',
            label: 'Review Type',
            dropdownId: 'reviewDropdown',
            value: '',
            readonly: isReadOnly,           
        });
        const reviewTypeData = JSON.parse(reviewTypes.getVendorLocationReviewTypeDropdownDataResult) || [];        
        reviewTypeData.unshift(defaultDropdownOption);
        dropdown.populate(reviewDropdown, reviewTypeData, reviewTypeId || '');

        const staffDropdown = dropdown.build({
            id: 'staffDropdown',
            label: 'Responsible Staff',
            dropdownId: 'staffDropdown',
            value: '',
            readonly: isReadOnly
        });
        const staffData = JSON.parse(staffs.getVendorLocationReviewStaffDropdownDataResult) || [];
        staffData.unshift(defaultDropdownOption);
        dropdown.populate(staffDropdown, staffData, staffId ||'');
    
        const dueDate = input.build({
            label: 'Due Date',
            id:'dueDateInput',
            type: 'date',
            style: 'secondary',
            value: dueDateValue,
            readonly: isReadOnly
        });
        const completedDate = input.build({
            label: 'Completed Date',
            type: 'date',
            style: 'secondary',
            value: completedDateValue,
            readonly: isReadOnly
        }); 
        const saveBtn = button.build({
            id: 'locationSave',
            text: data?'Apply':'Save',
            style: 'secondary',
            type: 'contained',
            callback: async () => {
                const result = await authorizationsAjax.saveVendorLocationReview({
                    id: data?.id || 0,
                    vendorId: vendorID,
                    locationId: locationId,
                    reviewTypeId: reviewTypeId,
                    staffId: staffId,
                    dueDate: dueDateValue,
                    completedDate: completedDateValue,
                });
                const saveResult = result.saveVendorLocationReviewResult;
                if (saveResult === 'success') {
                    POPUP.hide(locationReviewPopup);
                    successfulSave.show(data ? 'Updated' : 'Saved');
                    setTimeout(function () {
                        successfulSave.hide();
                    }, 2000);
                    locationReviewEntries = await authorizationsAjax.getVenderLocationReviewEntriesAsync(vendorID);
                    populateTable();
                }
                else if (saveResult === 'exists') {
                    POPUP.hide(locationReviewPopup);
                    showAlreadyExistsWarning();
                }
            },
        });
        const cancelBtn = button.build({
            id: 'locationCancel',
            text: 'cancel',
            style: 'secondary',
            type: 'outlined',
            callback: () => {
                POPUP.hide(locationReviewPopup);
            },
        });
        const btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        if (!isReadOnly) {
            btnWrap.appendChild(saveBtn);
        }
        btnWrap.appendChild(cancelBtn);

        locationReviewPopup.appendChild(locationDropdown);
        locationReviewPopup.appendChild(reviewDropdown);
        locationReviewPopup.appendChild(staffDropdown);
        const dateWrap = document.createElement('div');
        dateWrap.style.display = 'grid';
        dateWrap.style.gridTemplateColumns = '1fr 1fr';
        dateWrap.style.gap = '10px';
        dateWrap.style.marginBottom = '10px';
        dateWrap.style.width = '100%';
        dateWrap.appendChild(dueDate);
        dateWrap.appendChild(completedDate);
        locationReviewPopup.appendChild(dateWrap);
        const errorMsg = document.createElement('p');
        errorMsg.style.display = 'none';
        errorMsg.style.marginBottom = '15px';
        errorMsg.style.marginTop = '-15px';
        errorMsg.style.color = 'red';
        errorMsg.textContent = 'Due Date cannot be greater than the Completed Date';
        locationReviewPopup.appendChild(errorMsg);
        locationReviewPopup.appendChild(btnWrap);
        POPUP.show(locationReviewPopup);
        validatePopupFields();

        locationDropdown.addEventListener('change', async function (e) {
            locationId = e.target.value;
            await populateDueDate();
            validatePopupFields();
        });
        reviewDropdown.addEventListener('change', async function (e) {
            reviewTypeId = e.target.value;   
            await populateDueDate();
            validatePopupFields();
        });
        staffDropdown.addEventListener('change', function (e) {
            staffId = e.target.value || null;      
            validatePopupFields();
        });
        dueDate.addEventListener('change', function (e) {
            dueDateValue = e.target.value === '' ? null : e.target.value;           
            validatePopupFields();
        });
        completedDate.addEventListener('change', function (e) {
            completedDateValue = e.target.value === '' ? null : e.target.value;   
            validatePopupFields();
        });
        async function populateDueDate() {
            const dateField = document.getElementById('dueDateInput');
            dateField.value = '';
            dueDateValue = '';            
            if (reviewTypeId && locationId) {
                const result = await authorizationsAjax.getLocationReviewDueDate(vendorID, locationId, reviewTypeId);
                const date = JSON.parse(result.getLocationReviewDueDateResult);
                if (date && date.length > 0 && date[0].dueDate !== '') {
                    dueDateValue = moment(date[0].dueDate).format('YYYY-MM-DD');
                    dateField.value = dueDateValue;                   
                }              
            }
            validatePopupFields();            
        }
        function validatePopupFields() {
            if (locationId === null || locationId === '') {
                locationDropdown.classList.add('error');
            }
            else {
                locationDropdown.classList.remove('error');
            }

            if (reviewTypeId === null || reviewTypeId === '') {
                reviewDropdown.classList.add('error');
            }
            else {
                reviewDropdown.classList.remove('error');
            }

            if (dueDateValue === null || dueDateValue === '' ) {
                dueDate.classList.add('error');
            }
            else {
                dueDate.classList.remove('error');
            }
            errorMsg.style.display = 'none';
            if ((dueDateValue !== null && completedDateValue !== null) && dueDateValue > completedDateValue) {
                errorMsg.style.display = 'block';
            } 
            var locationReviewPopupDiv = document.getElementById('locationReviewPopup');
            var hasErrors = [].slice.call(locationReviewPopupDiv.querySelectorAll('.error:not(button)'));
            if (hasErrors.length === 0) {
                saveBtn.classList.remove('disabled');
                const newData = { id: data?.id, locationId, reviewTypeId, staffId, dueDate: dueDateValue, completedDate: completedDateValue || '' };
                const isChanged = data && JSON.stringify(data) !== JSON.stringify(newData);      
                if (errorMsg.style.display === 'block' || (data && !isChanged)) {
                    saveBtn.classList.add('disabled');
                }
            } else {
                saveBtn.classList.add('disabled');
            }
        }
        function showAlreadyExistsWarning() {
            var warningPopup = POPUP.build({});
            warningPopup.classList.add('warning');
            var message = document.createElement('p');
            message.innerHTML = 'This Location Review overlaps with an existing Location Review.';
            message.style.marginBottom = '15px';
            var btnWrap = document.createElement('div');
            btnWrap.classList.add('btnWrap');
            var okBtn = button.build({
                text: 'Ok',
                type: 'contained',
                style: 'secondary',
                callback: () => {
                    POPUP.hide(warningPopup);
                    POPUP.show(locationReviewPopup);
                }
            });

            btnWrap.appendChild(okBtn);
            warningPopup.appendChild(message);
            warningPopup.appendChild(btnWrap);
            POPUP.show(warningPopup);
            warningPopup.querySelector('.closePopupBtn').remove();
        }
    }
    return {
        init,
        buildNewVendorLocationReviewForm,
        getMarkup,
        showLocationReviewPopup,
    };
})(); 
